import type { Region } from '~~/core/entities/Region';
import { Result } from '~~/core/helpers/result';
import type { RegionService } from '~~/core/ports/services/RegionService';

// Futuramente usaremos um serviço externo para armazenar as informações dos bairros, por isso não criamos essa parte como um repositório
export const nuxtRegionService: RegionService = {
	async getOne({ slug }) {
		try {
			const response = await $fetch<Region | null>(`/api/region/${slug}`, {
				method: 'GET',
			});

			return Result.ok(response || null);
		} catch (error) {
			return Result.error({
				message: `Error while getting the region with slug ${slug}.`,
				source: 'nuxtRegionService.getOne',
				originalErrorObject: error as Error
			});
		}
	}
};
